import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a665.864 665.864 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 814.076c0-1.668-.093-2.873-.093-4.541h10.634v-8.211c-6.732.216-14.017.716-20.321-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.21h10.058c0 1.67.093 2.874.093 4.542-7.897-.055-17.336-.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 814.076c0-1.668-.092-2.873-.092-4.541h10.634v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.838 12.417-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.21h10.058c0 1.67.092 2.874.092 4.542-7.896-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 957.648c0 1.668-.093 2.873-.093 4.541h10.634v8.212c-6.732-.217-14.017-.717-20.321 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.366-5.71-1.582-11.49-1.301-17.354-1.057v-8.212h10.058c0-1.668.093-2.873.093-4.54-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 957.648c0 1.668-.092 2.873-.092 4.541h10.634v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.226 8.913-5.242 14.039.842 5.782 4.056 10.918 8.25 14.873 5.458 5.837 12.417 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.491-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.896.055-17.336.055-25.865 0z"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.93673 1.06755)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M28.418 706.772q0 .386-.147.754-.331.184-.7.184H15.754q-1.362 0-1.362-1.38 0-.221.037-.773.036-.552.036-.847 0-.644.276-.828.203-.13.902-.13h4.602v-2.834H9.92q-1.602 0-1.602-1.49 0-.259.055-.94.056-.7.056-1.104 0-.626.718-1.565l10.64-13.99q.496-.662 1.25-.662h2.43q.866 0 .866.957v15.02q.662 0 1.51-.036.864-.037 1.104-.037.994 0 1.233.497.24.479.24 2.393 0 .35-.056.534-.11.423-.847.423h-3.184v2.835q.68 0 1.546-.037.865-.037 1.086-.037 1.05 0 1.27.534.184.442.184 2.559zm-8.1-19.696q-1.011 1.546-7.472 10.069h7.4q0-.976-.038-3.35-.055-2.154-.036-3.37.018-1.84.147-3.35z"
                            fontSize="37.699"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.93673 -1.06755)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-221.388-952.85q0 .386-.147.754-.331.184-.7.184h-11.817q-1.362 0-1.362-1.38 0-.221.037-.773.036-.553.036-.847 0-.644.276-.828.203-.13.902-.13h4.602v-2.834h-10.326q-1.602 0-1.602-1.491 0-.258.055-.939.056-.7.056-1.104 0-.626.718-1.565l10.64-13.99q.496-.662 1.25-.662h2.43q.866 0 .866.957v15.02q.662 0 1.51-.036.864-.037 1.104-.037.994 0 1.233.497.24.478.24 2.393 0 .35-.056.534-.11.423-.847.423h-3.184v2.835q.68 0 1.546-.037.865-.037 1.086-.037 1.05 0 1.27.534.184.442.184 2.559zm-8.099-19.696q-1.012 1.546-7.473 10.068h7.4q0-.975-.037-3.35-.056-2.153-.037-3.368.018-1.841.147-3.35z"
                            fontSize="37.699"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
